export default "/_next/static/images/section-1-6be3c1a56710036af33c9aefaf648c6d.png";